import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

//import { Pro } from '@ionic/pro';
//import { Injectable, Injector } from '@angular/core';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { LoginProvider } from '../providers/login-provider';
import { LoginPage } from '../pages/login/login';
import { WelcomePage } from '../pages/welcome/welcome';
import { SharedDataProvider } from '../providers/shared-data-provider';
import { ConfigurationDataProvider } from '../providers/configuration-data-provider';
import { ModuleProvider } from '../providers/module-provider';
import { ReceiptProvider } from '../providers/receipt/receipt';
import { VendorProvider } from '../providers/vendor/vendor';
import { ArticleProvider } from '../providers/article/article';
import { BinTypeProvider } from '../providers/bin-type/bin-type';
import { BinProvider } from '../providers/bin/bin';
import { StockProvider } from '../providers/stock/stock';
import { LocationProvider } from '../providers/location/location';
import { LocationSearchProvider } from '../providers/location-search/location-search';
import { TaskSearchProvider } from '../providers/task-search/task-search';
import { TaskProvider } from '../providers/task/task';
import { TaskLogicProvider } from '../providers/task-logic/task-logic';
import { LocationLogicProvider } from '../providers/location-logic/location-logic';
import { InventoryLogicProvider } from '../providers/inventory-logic/inventory-logic';


/**
 * Automatic ionic pro error capturing
 */
/*const IonicPro = Pro.init('4229234c', {
  appVersion: "0.1.0-dev"
});*/

/*@Injectable()
export class IonicProErrorHandler implements ErrorHandler {
  ionicErrorHandler: IonicErrorHandler;

  constructor(injector: Injector) {
    try {
      this.ionicErrorHandler = injector.get(IonicErrorHandler);
    } catch(e) {
      // Unable to get the IonicErrorHandler provider, ensure 
      // IonicErrorHandler has been added to the providers list below
    }
  }

  handleError(err: any): void {
    IonicPro.monitoring.handleNewError(err);
    // Remove this if you want to disable Ionic's auto exception handling
    // in development mode.
    this.ionicErrorHandler && this.ionicErrorHandler.handleError(err);
  }
}*/



@NgModule({
  declarations: [
    MyApp,
    HomePage,
    LoginPage,
    WelcomePage
  ],
  imports: [
    BrowserModule, HttpClientModule,
    IonicModule.forRoot(MyApp),
    BrowserAnimationsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    LoginPage,
    WelcomePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    LoginProvider,
    SharedDataProvider,
    ConfigurationDataProvider,
    ModuleProvider,
    IonicErrorHandler,
    /*{provide: ErrorHandler, useClass: IonicProErrorHandler},*/
    ReceiptProvider,
    VendorProvider,
    ArticleProvider,
    BinTypeProvider,
    LocationProvider,
    BarcodeScanner,
    BinProvider,
    StockProvider,
    LocationSearchProvider,
    TaskSearchProvider,
    TaskProvider,
    TaskLogicProvider,
    LocationLogicProvider,
    InventoryLogicProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts